import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import pageActions from 'core/page/actions';
import dataActions from 'core/data/actions';
import { withStyles } from 'theme/withStyles';
import BottomContent from 'common/BottomContent';
import hasError from 'utils/hasError';
import ErrorMsg from 'common/ErrorMsg';
import RawHtml from 'common/RawHtml';
import ListGroup from 'containers/ListGroup';
import ButtonRowGroup from './common/ButtonRowGroup';

import commonStyles from './styles';

const styles = (theme) => ({
  ...commonStyles(theme),
  addUser: {
    display: 'block',
    margin: '50px auto 0',
  },
});

const BeneficiariesBare = ({
  bottomContent,
  classes,
  disableButton,
  hasFields,
  label,
  labelMobile,
  listGroup,
  name,
  onAdd,
  onEdit,
  onRemove,
  subText,
}) => (
  <>
    <legend
      className={classnames('grp-label', classes.label)}
      role={!hasFields ? 'presentation' : undefined}
    >
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>
    <div className="beneficiaries-group-view">
      <RawHtml className={classnames('content', classes.content)}>{subText}</RawHtml>

      <ErrorMsg name={name} type="group" />

      <ListGroup groupName={name} onRemove={onRemove} onEdit={onEdit} />

      <RawHtml
        className={classnames('btn btn-mobile btn-tertiary btn-add-beneficiary', classes.addUser)}
        data-name="btn-add-beneficiary"
        type="button"
        onClick={onAdd}
        variant="secondary"
        disabled={disableButton}
      >
        {listGroup.addButtonLabel}
      </RawHtml>

      <BottomContent className="bottomContent">{bottomContent}</BottomContent>

      <ButtonRowGroup groupName={name} />
    </div>
  </>
);

BeneficiariesBare.propTypes = {
  bottomContent: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  disableButton: PropTypes.bool,
  hasFields: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  listGroup: PropTypes.shape({
    addButtonLabel: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  subText: PropTypes.string,
};

BeneficiariesBare.defaultProps = {
  bottomContent: '',
  disableButton: false,
  hasFields: false,
  label: '',
  labelMobile: '',
  listGroup: {},
  subText: '',
};

BeneficiariesBare.defaultProps = {};

const BeneficiariesStyled = withStyles(styles)(BeneficiariesBare);

const mapStateToProps = ({ data, fields, groups }, { name }) => {
  const group = groups[name];

  return {
    bottomContent: group.bottomContent,
    disableButton:
      hasError(fields) || Object.values(data[`${name}___list`])?.length >= group.listGroup.maxItems,
    hasFields: group?.fields?.length > 0 ?? false,
    label: group.label,
    labelMobile: group.labelMobile,
    listGroup: group.listGroup,
    subText: group.subText,
  };
};

const mapDispatchToProps = {
  onAdd: pageActions.addBeneficiary,
  onEdit: dataActions.changeListGroupData,
  onRemove: pageActions.removeBeneficiary,
};

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiariesStyled);
